module.exports = __webpack_public_path__ + "img/klienci_inactive.c94a9680.svg";